import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HalkaArzResolver } from '../core/resolver/halka-arz-resolver';
import { HomeResolver } from '../core/resolver/home-resolver';
import { DetailComponent } from './detail/detail.component';
import { HomeComponent } from './home/home.component';
import { PublicOfferingComponent } from './public-offering.component';

const routes: Routes = [
  { path: '', component: PublicOfferingComponent,
  children: [
    { path: 'tr/halka-arz/:url',resolve: { halkaArzResolver: HalkaArzResolver  }, component: DetailComponent},
    { path: 'tr/halka-arz',resolve: { halkaArzResolver: HalkaArzResolver  }, component: HomeComponent},
    { path: 'halka-arz',resolve: { halkaArzResolver: HalkaArzResolver  }, component: HomeComponent},
    { path: '',resolve: { homeResolver: HomeResolver  }, component: HomeComponent}
  ]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicOfferingRoutingModule { }
